import { render, staticRenderFns } from "./PlayerListView.vue?vue&type=template&id=4195ea49&"
import script from "./PlayerListView.vue?vue&type=script&lang=js&"
export * from "./PlayerListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
